import { Component, OnInit, signal } from "@angular/core";
import { BackgroundGradient } from "../../../components/BackgroundGradient";
import { InstallFooter } from "../../../components/InstallFooter";
import { Button, Header, Wrap } from "../../../components";
import { Integration } from "../../../components/Integration";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CombiPackage, User } from "../../../model";
import { UserService } from "../../../services/user/user.service";
import { CombiPackageService } from "../../../services/combipackage/combipackage.service";
import { UserCombiPackageService } from "../../../services/usercombipackage/usercombipackage.service";
import { AppIntegration } from "../../../components/DashboardIntegrations";

@Component({
  selector: 'app-install-success-confirmed',
  standalone: true,
  imports: [
    BackgroundGradient,
    Button,
    Header,
    InstallFooter,
    Integration,
    TranslateModule,
    Wrap
  ],
  template: `
    <Header></Header>
    <div class="pb-12 md:pb-16 lg:pb-24 bg-blue-50 flex flex-col mt-2.5 relative">
      <Wrap [class]="'w-full max-w-[780px] flex flex-col gap-7.5 mt-8 z-10 relative'">
        <div class="card text-center md:px-15 py-12">
          <div class="text-6xl mb-4">🎉</div>
          <h2 class="h1 mb-4" translate="PAGE_INSTALL_CONFIRMED_TITLE"></h2>
          <p class="text-gray-600 max-w-sm mx-auto" [innerHTML]="'PAGE_INSTALL_CONFIRMED_BODY' | translate: { invoiceEmail: user?.invoiceEmail || user?.email }"></p>
          <div class="mt-8">
            <Button color="blue" href="/dashboard">
              {{ 'PAGE_INSTALL_CONFIRMED_CTA' | translate }}
            </Button>
          </div>
        </div>

        @if (recommendedIntegrations()?.length && combiPackage) {
          <div id="save-more-time">
            <h3 translate="PAGE_COMBIPACKAGEINSTALLED_SAVEMORETIME_TITLE"></h3>
            <p translate="PAGE_COMBIPACKAGEINSTALLED_SAVEMORETIME_BODY" [translateParams]="{ fromApiName: combiPackage.apiName, toApiName: combiPackage.otherApiName }"></p>

            <div class="grid sm:grid-cols-2 lg:grid-cols-2 gap-5 mb-7.5">
              @for (integration of recommendedIntegrations(); track integration.internalKey) {
                <Integration
                    [firstApp]="integration.from"
                    [secondApp]="integration.to"
                    [integration]="integration"
                ></Integration>
              }
            </div>

            <Button
                [color]="'blue'"
                [outline]="true"
                [href]="'/' + ('BREADCRUMBS_INTEGRATIONS_ROUTE' | translate) + '/' + combiPackage.apiName">
              + {{ 'PAGE_COMBIPACKAGEINSTALLED_BUTTON_MORE' | translate }}
            </Button>
          </div>
        }
      </Wrap>
      <BackgroundGradient/>
    </div>
    <InstallFooter/>
  `
})
export class InstallSuccessConfirmedComponent implements OnInit {
  user: User;
  combiPackage: CombiPackage;
  readonly recommendedIntegrations = signal<Array<AppIntegration> | undefined>(undefined);

  constructor(private userService: UserService,
              private translate: TranslateService,
              private combiPackageService: CombiPackageService,
              private userCombiPackageService: UserCombiPackageService) {}

  async ngOnInit() {
    this.user = this.userService.getUser();
    this.combiPackage = this.userCombiPackageService.getCombiPackage();

    if (this.combiPackage?.internalKey) {
      const recommendedCombiPackages = await this.combiPackageService.getRecommendedCombiPackagesForPackage(this.combiPackage.internalKey);
      this.recommendedIntegrations.set(recommendedCombiPackages
          .map(value => AppIntegration.fromCombiPackage(value, this.translate)));
    }
  }
}
